import React from 'react';
import { Table, Button } from 'semantic-ui-react';


const VehicleTable = ({
    vehicles, activateEditRequest, writePrivilege, switchToDetails, deleteVehicle, getSortedVehicles, fieldName, direction
}) => (
    <Table celled selectable sortable>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell
                    sorted={fieldName === 'manufacturer' ? direction : null}
                    onClick={() => getSortedVehicles('manufacturer', 'name')}
                >Proizvođač
                </Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'model' ? direction : null}
                    onClick={() => getSortedVehicles('model')}
                >Model
                </Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'licencePlate' ? direction : null}
                    onClick={() => getSortedVehicles('licencePlate')}
                >Tablice
                </Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'chassisNumber' ? direction : null}
                    onClick={() => getSortedVehicles('chassisNumber')}
                >Broj šasije
                </Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'purchaseYear' ? direction : null}
                    onClick={() => getSortedVehicles('purchaseYear')}
                >Godina nabavke
                </Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'status' ? direction : null}
                    onClick={() => getSortedVehicles('status', 'name')}
                >Status
                </Table.HeaderCell>
                {writePrivilege &&
                    <Table.HeaderCell></Table.HeaderCell>
                }
            </Table.Row>
        </Table.Header>

        <Table.Body>
            {vehicles.map(el =>
                (
                    <Table.Row key={el.id}>
                        <Table.Cell onClick={() => switchToDetails(el)}>{!!el.manufacturer && el.manufacturer.name}</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{el.model}</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{el.licencePlate}</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{el.chassisNumber}</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{el.purchaseYear}</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{!!el.status && el.status.name}</Table.Cell>

                        {writePrivilege &&
                            <Table.Cell verticalAlign="middle" className="text-center">
                                <Button
                                    basic
                                    color="green"
                                    size="small"
                                    onClick={() => activateEditRequest(el)}
                                >
                                    Uredi
                                </Button>
                                {
                                // <Button
                                //     basic
                                //     color="red"
                                //     size="small"
                                //     circular
                                //     icon="delete"
                                //     onClick={() => deleteVehicle(el.id)}
                                // />
                                }
                            </Table.Cell>
                        }
                    </Table.Row>
                ))
            }
        </Table.Body>
    </Table>);

export default VehicleTable;



// WEBPACK FOOTER //
// ./src/views/Assets/Vehicles/VehicleTable.js